/**
 * Vuex store 主入口
 */
import { createStore } from 'vuex'
import user from './modules/user'

const store = createStore({
  modules: {
    user
  }
})

export default store
